import React from 'react';
import styled from 'styled-components';
import Proptypes from 'prop-types';

const StyledIconBox = styled(({ children, as: Component, ...props }) => (
  <Component {...props}>{children}</Component>
))`
  width: ${(props) => props?.size};
  height: ${(props) => props?.size};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: ${(props) => props.$marginRight};
  margin-bottom: ${(props) => props.$marginBottom};
  border-radius: ${(props) => (props.$circle ? '50%' : '6px')};
  color: ${({ theme, $color }) => ($color ? theme[$color] : theme.white)};
  background-color: ${({ theme, $bgColor }) =>
    $bgColor ? theme[$bgColor] : theme.primary};

  svg {
    fill: ${({ fill }) => fill || 'currentColor'};
  }

  text-decoration: none;

  &:hover {
    text-decoration: none;
    color: ${({ theme, $color }) => ($color ? theme[$color] : theme.white)};
    transform: scale(${(props) => (props.$scale ? 1.3 : 1)});
  }

  button {
    border: none !important;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  ${(props) => {
    if (props?.filled) {
      return `border: none;
      padding: 5px;
      &:hover {
      background: ${props?.theme?.inputBorder};
      border-radius: 3px;
      }`;
    }
    return '';
  }};
`;
StyledIconBox.defaultProps = {
  $marginRight: '5px',
  $marginBottom: '0',
  size: '40px',
  $textColor: '#fff',
  as: 'div',
};
StyledIconBox.propTypes = {
  size: Proptypes.string,
  $marginRight: Proptypes.string,
  $marginBottom: Proptypes.string,
  color: Proptypes.string,
  $textColor: Proptypes.string,
  $circle: Proptypes.bool,
  $scale: Proptypes.bool,
};
export default StyledIconBox;
